import { z } from 'zod';

import type { TranslationFnMap } from '~shared/i18n';

type InstagramShareErrorsKey = 'PHOTO_REQUIRED';

export type InstagramShareFormErrors =
  TranslationFnMap<InstagramShareErrorsKey>;

export const MAX_CAPTION_LENGTH = 2200;

export const instagramShareSchema = z.object({
  caption: z
    .string()
    .min(1, { error: 'MESSAGE_REQUIRED' })
    .max(MAX_CAPTION_LENGTH, { error: 'MESSAGE_TOO_LONG' }),
  imageUrls: z.array(z.string()).min(1, { error: 'PHOTO_REQUIRED' }),
});

export type InstagramShareFormValues = z.infer<typeof instagramShareSchema>;
